export const ENABLE_AMPLITUDE = 'EnableAmplitude';
export const ENABLE_GA = 'EnableGA';
export const ENABLE_FW_UPDATES_CHECK = 'EnableFWUpdatesCheck';
